export const INVITATION_STATUSES = {
  pending: 0,
  success: 1,
  inactive: 4,
  corrupted: 100,
  failedIdentification: 101,
}

export const INVITATION_CAN_ACCEPT_FROM = [INVITATION_STATUSES.pending]
